module.exports = __webpack_public_path__ + "static/overlay-meteors-10d17fd0d8b3d84153792de886780d8f.png";